import { Headers } from '@egw/components'
import { CashAccountsOverviewRedesignPage } from '@egw/features-account'
import { useTranslation } from '@egw/i18n'
import { RedesignLayout } from '@egw/layouts'
import { type FC } from 'react'

export const CashAccountsOverviewPage: FC = () => {
  const { t } = useTranslation('features-account')

  return (
    <RedesignLayout>
      <Headers title={t('overview.cash_accounts')} />
      <CashAccountsOverviewRedesignPage />
    </RedesignLayout>
  )
}
